import React, { useState } from 'react';
import styles from './OrganisationType.module.scss';
import RadioButtonList from '../radioButtonList/RadioButtonList';
import ToolTip from '../toolTip/ToolTip';

const OrganisationType = props => {
  const options = [];
  if (!props.disableABN || !props.disableABN) {
    options.push({ value: 'ABN', label: 'ABN' });
  }

  if (!props.disableACN || !props.disableACN) {
    options.push({ value: 'ACN', label: 'ACN' });
  }

  const [isAbn, setAbn] = useState(
    props.regoType ? { checked: true, label: props.regoType, value: props.regoType } : null
  );
  const [errors, setErrors] = useState({
    isAbn: false,
  });

  return (
    <>
      <div className={'row'}>
        <div className={'col-12'}>
          <div className={styles.titleDiv}>
            <span className={styles.title}>Registration type</span>
          </div>
          {props.hideHelpMessage ? null : (
            <ToolTip
              id={'ownBusinessToolTip'}
              name={'ownBusinessToolTip'}
              title={'Why do we ask for this?'}
              text={
                props.helpMessage
                  ? props.helpMessage
                  : `This information will help the organisations you notify to identify the correct account in their system.`
              }
            />
          )}
          <fieldset className={`nsw-form-fieldset ${styles.nswFormFieldset}`}>
            <RadioButtonList
              list={[
                {
                  value: 'ABN',
                  label: 'ABN',
                  checked: isAbn && isAbn.value === 'ABN' ? true : false,
                },
                {
                  value: 'ACN',
                  label: 'ACN',
                  checked: isAbn && isAbn.value === 'ACN' ? true : false,
                },
              ]}
              id={'selectAbn'}
              name={'selectAbn'}
              displayLayout={'horizontal'}
              handleChange={(item, name) => {
                setAbn(item);
                props.setRegoType(item.label);
              }}
              aria-describedby={errors.isAbn ? 'isAbnErrorMessage' : undefined}
              aria-invalid={`${errors.isAbn ? 'true' : 'false'}`}
            ></RadioButtonList>
          </fieldset>
        </div>
      </div>
    </>
  );
};
export default OrganisationType;
